import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialUiModule } from '@cpd-app/shared-module/material-ui-module/material-ui.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogModule } from '../dialog/dialog.module';
import { ButtonModule } from '../button/button.module';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MaterialUiModule,
    FontAwesomeModule,
    DialogModule,
    ButtonModule
  ],
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; content: string; icon: string },
    private dialogRef: MatDialogRef<MessageDialogComponent>
  ) {
    this.dialogRef.addPanelClass('message-dialog');
  }
}
